import React, { useEffect, useState } from "react";
import { Button, Form, Input, Modal, Select, Space, Table } from "antd";
import { CloseOutlined, UndoOutlined } from "@ant-design/icons";
import Styles from "./Styles";
import SearchArea from "../../components/moleculas/SearchArea";
import RegistForm from "../../components/moleculas/RegistForm";
import { apiGetSitesComp, apiPutEquipment, apiPostEquipment, apiGetEquipmentSite, apiGetMasterCode } from "../../api/api";
import "./ManageServiceUser.css";
import {
  autoTelHyphenConvert,
  getSessionParam,
  isEmpty,
  setSessionParam,
  sortData,
  getGlobalSessionParam,
} from "../../utils/comm";

const { Option } = Select;
const { Search } = Input;
const { Column } = Table;

function ManageEquipment() {
  const telRegExp = /^(0(2|3[1-3]|4[1-4]|5[1-5]|6[1-4]))-(\d{3,4})-(\d{4})$/;
  const phoneRegExp = /^(?:(010-\d{4})|(01[1|6|7|8|9]-\d{3,4}))-(\d{4})$/;

  // Parameter Save
  const [defaultValue] = useState({
    siteId: !isEmpty(getGlobalSessionParam("siteId")) ? getGlobalSessionParam("siteId") : null,
  });

  // Start of View Data
  // 검색 데이터
  const [searchForm, setSearchForm] = useState({
    siteId: defaultValue.siteId,
    searchKeyword: null,
  });
  const [data, setData] = useState([]); // 장비 목록 데이터
  const [form] = Form.useForm(); // 장비 저장(추가/수정) form 데이터
  const [equiList, setEquiList] = useState([]); // 장비 목록 데이터
  // End of View Data

  // Start of DATA
  // 사업장 목록
  const [siteList, setSiteList] = useState(
    !isEmpty(searchForm.siteId) && !isEmpty(searchForm.siteNm)
      ? [
          {
            siteId: searchForm.siteId,
            siteNm: searchForm.siteNm,
          },
        ]
      : []
  );
  // End of DATA

  // Start of 초기화
  useEffect(() => {
    initData().then();
  }, []);

  // 데이터 초기화
  const initData = async () => {
    await getMastEqui();

    // 사업장 목록 데이터
    await getSiteCompList();

    await getEquiList();
  };
  // End of 초기화

  // Start of API Function
  
  // 장비 마스터 코드
  const getMastEqui = async () => {
    const model = {
      catCd: 'EQU',
    };
    try {
      const response = await apiGetMasterCode(model);
      if (response.data.code === 0) {
        setEquiList(response.data.data);
      } else {
        setEquiList([]);
      }
    } catch (e) {}
  };

  // 사업장 목록 조회
  const getSiteCompList = async () => {
    const model = {
      compId: sessionStorage.getItem("compId"),
      userId: sessionStorage.getItem("userId"),
    };
    try {
      const response = await apiGetSitesComp(model);
      if (response.data.code === 0) {
        setSiteList(response.data.data);
      } else {
        setSiteList([]);
      }
    } catch (e) {}
    setSearchForm({ ...searchForm, ["siteId"]: searchForm.siteId });
  };

  // 장비 목록 조회
  const getEquiList = async () => {
    try {
      const model = { ...searchForm };
      const response = await apiGetEquipmentSite(model);
      if (response && response.code === 0 && response.data && response.data.length > 0) {
        const resData = response.data;

        let inputData = new Array(resData.length).fill(null).map((value, index, array) => ({
          key: index,
          devId: resData[index].devId,
          devSn: resData[index].devSn,
          devNo: resData[index].devNo,
          devOrg: resData[index].devOrg,
          devModel: resData[index].devModel,
          user: resData[index].user == null ? "" : resData[index].user,
          tel: resData[index].tel,
          devTp: resData[index].devTp,
        }));

        const searchKeyword = searchForm.searchKeyword;
        if (searchKeyword == null) {
          setData(inputData);
        } else {
          inputData = inputData.filter(
            (data) =>
              equiList.find((item) => item.code === data.devTp).codeNm.includes(searchKeyword) ||
              data.devSn.includes(searchKeyword) ||
              data.devNo.includes(searchKeyword) ||
              data.devModel.includes(searchKeyword) ||
              data.user.includes(searchKeyword)
          );
          setData(inputData);
        }
      } else {
        setData([]);
      }
    } catch (e) {}
  };
  // End of API Function

  // Start of View Function
  // 사업장 선택
  const onChangeSiteId = async (value, option) => {
    await setSearchForm((prevSearchForm) => {
      let searchForm = { ...prevSearchForm };
      searchForm.siteId = option ? value : null;
      searchForm.siteNm = option ? option.children : null;
      return searchForm;
    });

    setSessionParam({
      siteId: option ? value : null,
      siteNm: option ? option.children : null,
    });

    getEquiList().then();
  };

  // 검색어 변경
  const onChangeSearchKeyword = async (e) => {
    await setSearchForm((prevSearchForm) => {
      let searchForm = { ...prevSearchForm };
      searchForm.searchKeyword = e.target.value;
      return searchForm;
    });
  };

  // 검색
  const onSearch = (resetFlag) => {
    if (resetFlag) searchForm.searchKeyword = "";

    getEquiList().then();
  };

  // 연락처 포맷
  const validateTelNumber = (validate, value) => {
    if (!isEmpty(value) && !telRegExp.test(value) && !phoneRegExp.test(value)) {
      return Promise.reject(new Error(validate.message));
    } else {
      return Promise.resolve();
    }
  };

  // 전화변호 입력 값이 변경될 때마다 하이픈을 자동으로 입력한다.
  const autoTelHyphenInput = (e) => {
    let telValue = e.target.value;
    const fields = form.getFieldsValue();
    form.setFieldsValue({
      ...fields,
      tel: autoTelHyphenConvert(telValue),
    });
  };

  // 리셋 버튼 동작
  const resetRegistForm = () => {
    form.resetFields();
    setData([]);

    getEquiList().then();
  };

  // 장비 삭제 함수
  const deleteEquipment = async (index) => {
    await apiPutEquipment(data[index].devId);
    await resetRegistForm();
  };

  // 삭제 버튼 클릭시 삭제 확인 창 호출
  const confirmDeleteEquipment = async (index) => {
    Modal.confirm({
      title: "장비 삭제",
      icon: null,
      content: "삭제하시겠습니까?",
      okText: "예",
      cancelText: "아니오",
      centered: true,
      onOk: () => deleteEquipment(index),
    });
  };

  // 로우 클릭 시 장비 저장 (수정/삭제) form 에 데이터 기입
  const userRowClick = async (data, index) => {
    let jsonObj = JSON.parse(JSON.stringify(data));
    form.setFieldsValue(jsonObj);
  };

  // 장비 추가(저장)
  const onSubmit = async (fields) => {
    fields = {
      ...fields,
      siteId: searchForm.siteId,
      devId: fields.devId === undefined ? null : fields.devId,
      user: fields.user === "" ? null : fields.user,
    };
    let strTitle = "저장 완료";
    let strContent = "저장이 완료되었습니다.";
    const res = await apiPostEquipment(fields);
    if (res.data.code != null && (res.data.code === 0 || res.data.code === 2)) {
      Modal.info({
        title: strTitle,
        icon: null,
        content: strContent,
        okText: "확인",
        centered: true,
        onOk() {
          resetRegistForm();
        },
      });
    } else {
      Modal.info({
        title: "오류 발생",
        icon: null,
        content: "오류가 발생되었습니다.",
        okText: "확인",
        centered: true,
        onOk() {
          resetRegistForm();
        },
      });
    }
  };
  // End of View Function

  return (
    <Styles className='has-table-resize'>
      <h1 className='page-tit'>장비 등록 관리</h1>
      <SearchArea
        leftExtra={
          <Space size={[12, "small"]}>
            <div className='condition-item'>
              <label htmlFor='s11'>사업장</label>
              <Select
                style={{ minWidth: 148 }}
                id='s11'
                placeholder='선택'
                value={searchForm.siteId}
                onChange={(value, option) => onChangeSiteId(value, option)}
              >
                {siteList.map((item, index) => (
                  <Option key={index} value={item.siteId}>
                    {item.siteNm}
                  </Option>
                ))}
              </Select>
            </div>
          </Space>
        }
        rightExtra={
          <Space className={"rpc-head-container"}>
            <Search
              className={"rpc-head-item"}
              placeholder='검색'
              value={searchForm.searchKeyword}
              onChange={onChangeSearchKeyword}
              onSearch={() => onSearch(false)}
            />
            <Button className='btn-gray rpc-head-button' onClick={() => onSearch(true)}>
              초기화
            </Button>
          </Space>
        }
      />
      <RegistForm
        onSubmit={onSubmit}
        form={form}
        items={
          <>
            <div className='condition-item'>
              <label htmlFor='s1'>장비유형</label>
              <Form.Item name={"devId"} noStyle={true}>
                <Input type={"hidden"} />
              </Form.Item>
              <Form.Item name={"desc"} noStyle={true}>
                <Input type={"hidden"} />
              </Form.Item>
              <Form.Item
                hasFeedback={false}
                name={"devTp"}
                rules={[
                  {
                    required: true,
                    message: "",
                  },
                ]}
              >
                <Select
                  style={{ width: 112 }}
                  id='s1'
                  allowClear
                  showArrow={true}
                  showSearch={false}
                  placeholder='선택'
                >
                  {equiList.map((item, index) => (
                    <Option key={index} value={item.code}>
                      {item.codeNm}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </div>
            <div className='condition-item'>
              <label htmlFor='s2'>장비 ID</label>
              <Form.Item
                name={"devSn"}
                rules={[
                  {
                    required: true,
                    message: "",
                  },
                ]}
              >
                <Input style={{ width: 116 }} id='s2' maxLength={60} />
              </Form.Item>
            </div>
            <div className='condition-item'>
              <label htmlFor='s3'>관리번호</label>
              <Form.Item
                name={"devNo"}
                rules={[
                  {
                    message: "",
                  },
                ]}
              >
                <Input style={{ width: 96 }} id='s3' maxLength={100} />
              </Form.Item>
            </div>
            <div className='condition-item'>
              <label htmlFor='s4' style={{ minWidth: 24 }}>
                모델
              </label>
              <Form.Item
                name={"devModel"}
                rules={[
                  {
                    message: "",
                  },
                ]}
              >
                <Input style={{ width: 120 }} id='s4' maxLength={100} />
              </Form.Item>
            </div>
            <div className='condition-item'>
              <label htmlFor='s5'>기사 이름</label>
              <Form.Item name={"user"}>
                <Input style={{ width: 96 }} id='s5' maxLength={13} />
              </Form.Item>
            </div>
            <div className='condition-item'>
              <label htmlFor='s6'>기사 연락처</label>
              <Form.Item
                name={"tel"}
                rules={[
                  {
                    validator: validateTelNumber,
                    message: "",
                  },
                ]}
              >
                <Input style={{ width: 148 }} id='s6' maxLength={13} onChange={autoTelHyphenInput} />
              </Form.Item>
            </div>
            <div className='condition-item'>
              <label htmlFor='s7'>기사 소속</label>
              <Form.Item
                name={"devOrg"}
                rules={[
                  {
                    message: "",
                  },
                ]}
              >
                <Input style={{ width: 112 }} id='s7' maxLength={100} />
              </Form.Item>
            </div>
          </>
        }
        buttons={[
          <Button type='primary' key={"b1"} htmlType='submit'>
            저장
          </Button>,
          <Button size='small' key={"b2"} icon={<UndoOutlined />} onClick={resetRegistForm} />,
        ]}
      />

      <div className='tbl-resize-wrapper' style={{ minHeight: 300 }}>
        <Table
          dataSource={data}
          bordered
          pagination={false}
          showSorterTooltip={false}
          scroll={{ x: 1300 }}
          onRow={(data, index) => {
            return {
              onClick: () => userRowClick(data, index),
            };
          }}
        >
          <Column title='No' key='1' width='1%' render={(value, record, index) => index + 1} />
          <Column
            title='장비유형'
            dataIndex='devTp'
            key='2'
            width='6%'
            sorter={(a, b) =>
              sortData(
                equiList.find((item) => item.code === a.devTp).codeNm,
                equiList.find((item) => item.code === b.devTp).codeNm
              )
            }
            render={(value, record, index) => equiList.find((item) => item.code === value).codeNm}
          />
          <Column title='장비 ID' dataIndex='devSn' key='3' width='6%' sorter={(a, b) => sortData(a.devSn, b.devSn)} />
          <Column
            title='관리번호(차량번호 등)'
            dataIndex='devNo'
            key='4'
            width='6%'
            sorter={(a, b) => sortData(a.devNo, b.devNo)}
          />
          <Column
            title='모델'
            dataIndex='devModel'
            key='5'
            width='8%'
            sorter={(a, b) => sortData(a.devModel, b.devModel)}
          />
          <Column title='기사이름' dataIndex='user' key='6' width='5%' sorter={(a, b) => sortData(a.user, b.user)} />
          <Column title='기사 연락처' dataIndex='tel' key='7' width='8%' sorter={(a, b) => sortData(a.tel, b.tel)} />
          <Column
            title='기사 소속'
            dataIndex='devOrg'
            key='8'
            width='6%'
            sorter={(a, b) => sortData(a.devOrg, b.devOrg)}
          />
          <Column
            title='삭제'
            dataIndex='delete'
            key='9'
            width='3%'
            render={(value, record, index) => {
              const isOwn = record.userId === sessionStorage.getItem("userId");
              return (
                <Button
                  icon={<CloseOutlined />}
                  size='small'
                  className='btn-ico-del'
                  disabled={isOwn}
                  onClick={(e) => {
                    e.stopPropagation(); // row 클릭 이벤트 방지
                    confirmDeleteEquipment(record.key).then();
                  }}
                />
              );
            }}
          />
        </Table>
      </div>
    </Styles>
  );
}

export default ManageEquipment;
